import { Component, Input } from '@angular/core';
import { SkeletonComponent } from '../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-applications-skeleton',
  templateUrl: './applications-skeleton.component.html',
  styleUrls: ['./applications-skeleton.component.css'],
  imports: [SkeletonComponent],
})
export class ApplicationsSkeletonComponent {
  readonly rows = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  @Input() showOwnerFilter = false;   // isPlatformUser || isAMORETeam
  @Input() showExcludedFilter = false; // strategystatus === 'Excluded'
  @Input() showAssignmentDate = false;
}
